import { format, type FormatParams, defaults } from '@hh.ru/magritte-common-number-formatter';
import { InputFormatter } from '@hh.ru/magritte-ui-input/types';

const calculateDelimiters = (rawText: string, formatted: string, groupSeparator: string): number =>
    formatted.split(groupSeparator).length - rawText.trim().split(groupSeparator).length;

export const numberFormatterFactory: (params?: FormatParams) => InputFormatter = (passedParams = {}) => {
    const filteredParams = (Object.keys(passedParams) as Array<keyof typeof passedParams>).reduce<FormatParams>(
        (acc, key) =>
            passedParams[key] === undefined
                ? acc
                : {
                      ...acc,
                      [key]: passedParams[key],
                  },
        {}
    );
    const params = { ...defaults, ...filteredParams };
    const ouputFormatParams = {
        groupSeparator: '',
        decimalMark: ['.', ...params.decimalMark],
        allowNegative: params.allowNegative,
        decimalLength: params.decimalLength,
    };
    const decimalDelimitersRegExp = new RegExp(`[${params.decimalMark?.join('')}]`, 'g');

    return (prevValue: string, value: string, caretPosition: number) => {
        const decimalDelimitersCount = value.match(decimalDelimitersRegExp)?.length || 0;
        if (decimalDelimitersCount > 1) {
            const lastChar = prevValue.charAt(value.length - 1);
            const formattedValue = format(prevValue, params) + (params.decimalMark.includes(lastChar) ? lastChar : '');
            const decimalDelimitersPosition = formattedValue.search(decimalDelimitersRegExp);
            return {
                formattedValue,
                outputValue:
                    format(prevValue, ouputFormatParams) + (params.decimalMark.includes(lastChar) ? lastChar : ''),
                caretPosition: decimalDelimitersPosition + 1,
            };
        }
        const lastChar = value.charAt(value.length - 1);
        const prevLastChar = prevValue.charAt(prevValue.length - 1);
        const formattedValue = format(value, params) + (params.decimalMark.includes(lastChar) ? lastChar : '');
        const formattedPrevValue =
            format(prevValue, params) + (params.decimalMark.includes(prevLastChar) ? prevLastChar : '');
        const outputValue = format(value, ouputFormatParams) + (params.decimalMark.includes(lastChar) ? lastChar : '');
        // разница вы количестве разделителей разрядов между предыдушим и текущим значениями
        const delimitersDelta = calculateDelimiters(formattedPrevValue, formattedValue, params.groupSeparator);
        const prevValueFirstDelimiterPosition = formattedPrevValue.indexOf(params.groupSeparator) + 1;
        // если каретка находится левее первого символа разделителя разрядов, то не применяем сдвиг с учетом
        // разницы в количестве разделителей, т.к. сдвигаются только символы справа от первого разделителя
        const caret = caretPosition < prevValueFirstDelimiterPosition ? caretPosition : caretPosition + delimitersDelta;

        return {
            formattedValue,
            outputValue,
            caretPosition: formattedPrevValue === formattedValue ? Math.max(caret - 1, 0) : caret,
        };
    };
};
